import { system } from 'styled-system';
export var flexItem = system({
  flex: true,
  flexBasis: true,
  flexGrow: true,
  flexShrink: true
});